import { PlatformLocation } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';
import {BASE_PATH, InvitationService, TotpService} from '../../gen';
import { ApiModule } from '../../gen/api.module';
import { AuthenticationService } from '../../gen/api/authentication.service';
import { AuthenticationFlowService } from '../../gen/api/authenticationFlow.service';
import { EmailVerificationService } from '../../gen/api/emailVerification.service';
import { PasswordService } from '../../gen/api/password.service';
import { SessionService } from '../../gen/api/session.service';
import { UserService } from '../../gen/api/user.service';
import { Configuration } from '../../gen/configuration';
import { getApiBasePath } from './api-base-path';

@NgModule({
  providers: [
    { provide: 'AuthenticationApi', useClass: AuthenticationService },
    { provide: 'AuthenticationFlowApi', useClass: AuthenticationFlowService },
    { provide: 'SessionApi', useClass: SessionService },
    { provide: 'UserApi', useClass: UserService },
    { provide: 'EmailVerificationApi', useClass: EmailVerificationService },
    { provide: 'PasswordApi', useClass: PasswordService },
    { provide: 'InvitationApi', useClass: InvitationService },
    { provide: 'TotpApi', useClass: TotpService },
    { provide: BASE_PATH, useFactory: getApiBasePath, deps: [PlatformLocation] }
  ]
})
export class RealApiModule extends ApiModule {
  public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders {
    return {
      ngModule: RealApiModule,
      providers: [{ provide: Configuration, useFactory: configurationFactory }]
    };
  }

  constructor(@Optional() @SkipSelf() parentModule: ApiModule,
    @Optional() http: HttpClient) {
    super(parentModule, http);
  }
}
